import NeighborhoodPage from "@/components/NeighborhoodPage";
import heroImage from "@/assets/hero-botafogo.jpg?w=640;1024;1600;1920&format=avif;webp;jpg&as=picture";

const Botafogo = () => (
  <NeighborhoodPage
    name="Botafogo"
    slug="botafogo"
    description="Vista para o Pão de Açúcar, excelente infraestrutura e fácil acesso a toda a cidade. Um dos bairros mais desejados da Zona Sul."
    heroPicture={heroImage}
  />
);

export default Botafogo;
